import React, { useEffect } from 'react'
import { CheckboxHeaderCell, Table } from '@ztechapps/webui.data-tools'
import { useTasksPerProjectContext } from './Context'
import { ListRow } from './ListRow'
import { NullComponent } from '@ztechapps/webui.util'

const ListHeader = () => {
  const {
    listWithSelection: { toggleSelectAll, hasSelectedAll },
  } = useTasksPerProjectContext()

  return (
    <thead>
      <tr>
        <CheckboxHeaderCell onChange={toggleSelectAll} checked={hasSelectedAll} label={'Task Name'} />
      </tr>
    </thead>
  )
}

export const TaskList = () => {
  const { listWithSelection, onTaskSelect } = useTasksPerProjectContext()

  const list = listWithSelection.selectedList

  useEffect(() => {
    onTaskSelect?.({ tasks: list })
  }, [list, onTaskSelect])

  return (
    <Table emptyContent={<NullComponent />} head={<ListHeader />} row={ListRow} dataArray={listWithSelection.list} />
  )
}
